import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

interface OrderItemData {
    id: number;
    code: string;
    total: number;
    status: number;
    created_at: string;
    order_product: {
        quantity_product: number;
    }[];
}

interface OrderItemProps {
    data: OrderItemData;
}

const STATUS_MAP: Record<number, { label: string; color: string }> = {
    1: { label: "Chờ xác nhận", color: "#FFA500" },
    2: { label: "Đã xác nhận", color: "#1890ff" },
    3: { label: "Đang xử lý", color: "#1890ff" },
    4: { label: "Đang giao", color: "#1890ff" },
    5: { label: "Đã giao", color: "#52c41a" },
    6: { label: "Giao thành công", color: "#52c41a" },
    0: { label: "Đã hủy", color: "#f5222d" },
};

const OrderItem: React.FC<OrderItemProps> = ({ data }) => {
    const [openDocs, setOpenDocs] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    const toggleBtnRef = useRef<HTMLSpanElement | null>(null);

    const statusInfo = STATUS_MAP[data.status] || { label: "Không xác định", color: "#000" };
    const totalQuantity = data.order_product?.reduce((acc, item) => acc + item.quantity_product, 0) || 0;
    const productCount = data.order_product?.length || 0;

    const handleOpenDocs = (e: React.MouseEvent) => {
        e.preventDefault();    // ⛔ chặn href
        e.stopPropagation();   // ⛔ chặn bubble lên <a>

        setOpenDocs((prev) => !prev);
    };

    const handleFeedback = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        // TODO: mở modal phản hồi
        console.log("Feedback");
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            // 👉 Click vào nút toggle thì BỎ QUA
            if (toggleBtnRef.current?.contains(target)) {
                return;
            }

            // 👉 Click ra ngoài dropdown thì đóng
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(target)
            ) {
                setOpenDocs(false);
            }
        };

        if (openDocs) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDocs]);

    return (
        <div
            className="MuiGrid-root MuiGrid-container"
            style={{ position: "relative", zIndex: 0 }}
        >
            <a
                className="styles_mobile_rootBase__8z7PQ styles_w_100__dLF02"
                href={`/my-order/${data.id}`}
            >
                <div className="MuiGrid-root styles_orderInfoCard__3cJhk MuiGrid-item MuiGrid-grid-xs-12">
                    <div className="MuiGrid-root styles_wrapOrderList__3tDef MuiGrid-container">
                        {/* ===== ORDER CODE ===== */}
                        <div
                            className="MuiGrid-root styles_order_code_wrapper__BeZVy MuiGrid-container MuiGrid-item MuiGrid-grid-sm-3 MuiGrid-grid-md-3"
                            style={{ gap: "4px" }}
                        >
                            <p className="MuiTypography-root styles_orderCode__jgr30 MuiTypography-body1">
                                #{data.code} &nbsp;
                            </p>

                            <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2712%27%20height=%2712%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: "0px",
                                                padding: "0px",
                                            }}
                                        />
                                    </span>
                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/orderStatus/time.svg"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>

                                <p className="MuiTypography-root styles_timeOrder__9cc2E MuiTypography-body1">
                                    {dayjs(data.created_at).format("HH:mm:ss DD/MM/YYYY")}
                                </p>
                            </div>

                            <p className="MuiTypography-root styles_timeOrder__9cc2E MuiTypography-body1">
                                Không gửi yêu cầu xuất hóa đơn
                            </p>
                        </div>

                        {/* ===== PRICE ===== */}
                        <div
                            className="MuiGrid-root styles_order_code_wrapper__BeZVy MuiGrid-container MuiGrid-item MuiGrid-align-content-xs-flex-start MuiGrid-grid-sm-3 MuiGrid-grid-md-2"
                            style={{ gap: "4px" }}
                        >
                            <p className="MuiTypography-root styles_priceOrder__aWjor MuiTypography-body1">
                                {data.total.toLocaleString()}đ
                            </p>
                            <div className="MuiGrid-root MuiGrid-container MuiGrid-item">
                                <p className="MuiTypography-root styles_quantityOrder__6drdj MuiTypography-body1">
                                    Sản phẩm{" "}
                                    <span className="styles_numberBold__Y_nQc">{productCount}</span> - Tổng SL{" "}
                                    <span className="styles_numberBold__Y_nQc">{totalQuantity}</span>
                                </p>
                            </div>
                        </div>

                        {/* ===== STATUS ===== */}
                        <div
                            className="MuiGrid-root styles_order_time_wrapper___yz3C MuiGrid-container MuiGrid-item MuiGrid-align-content-xs-flex-start MuiGrid-grid-sm-3 MuiGrid-grid-md-2"
                            style={{ gap: "4px" }}
                        >
                            <div className="MuiGrid-root styles_statusOrder__E64sW MuiGrid-container MuiGrid-align-items-xs-center">
                                <div
                                    className="styles_statusDot__7UkdW MuiBox-root css-0"
                                    style={{ backgroundColor: statusInfo.color }}
                                ></div>
                                <p className="MuiTypography-root MuiTypography-body1">
                                    {statusInfo.label}
                                </p>
                            </div>

                            <div className="MuiGrid-root styles_deliveryDate__v3TzE MuiGrid-container MuiGrid-item">
                                <p className="MuiTypography-root MuiTypography-body1">
                                    Dự kiến giao <span>Thứ bảy (24/01/2026)</span>
                                </p>
                            </div>
                        </div>

                        {/* ===== ACTION BUTTONS ===== */}
                        <div className="MuiGrid-root styles_order_btn_wrapper__dV_Yy MuiGrid-container MuiGrid-item MuiGrid-grid-md-5">
                            <div className="MuiGrid-root styles_groupBtn__h_kv_ MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-flex-end">
                                <button
                                    className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnData__Urq7T"
                                    type="button"
                                    aria-haspopup="true"
                                >
                                    <span className="MuiButton-label" onClick={handleOpenDocs} ref={toggleBtnRef}>
                                        Giấy tờ (1)
                                        <svg
                                            className="MuiSvgIcon-root styles_btnIcon__fvZHb"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root"></span>
                                    {openDocs && (
                                        <div
                                            style={{ position: "absolute", bottom: "110%", right: "50%", willChange: "transform", transform: "translateX(50%)" }}
                                            data-placement="bottom"
                                            ref={dropdownRef}
                                            className="dropdown-docs"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                        >
                                            <div
                                                className="MuiPaper-root styles_Paper__FC9Yi MuiPaper-elevation1 MuiPaper-rounded"
                                                style={{ opacity: 1, transform: "none", transformOrigin: "left center", position: "relative", zIndex: 999999, border: "1px solid rgb(233, 233, 233)", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 6px", transition: "opacity 243ms cubic-bezier(0.4, 0, 0.2, 1), transform 162ms cubic-bezier(0.4, 0, 0.2, 1)" }}
                                            >
                                                <ul className="MuiList-root styles_invoiceList__nhSXj MuiList-padding !pb-0 !mb-0" role="menu" tabIndex={-1} id="menu-list-grow">
                                                    <div
                                                        className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-flex-end MuiGrid-grid-xs-12"
                                                        tabIndex={0}
                                                        style={{ padding: "0px 10px" }}
                                                    >
                                                        <svg onClick={handleOpenDocs} className="MuiSvgIcon-root styles_iconCancel__uA1NZ" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"></path>
                                                        </svg>
                                                    </div>
                                                    <div
                                                        className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12"
                                                        style={{ padding: "0px 16px" }}>
                                                        <p className="MuiTypography-root styles_data__5OwHg MuiTypography-body1">Giấy tờ</p>
                                                        <p className="MuiTypography-root styles_desInvoice__z285E MuiTypography-body1">1 tệp</p>
                                                    </div>
                                                    <hr className="MuiDivider-root" />
                                                    <li className="MuiButtonBase-root MuiListItem-root MuiMenuItem-root MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button" tabIndex={-1} role="menuitem" aria-disabled="false">
                                                        <button className="styles_exportXLSX__QO7Gq">
                                                            <p className="!mb-0">Danh sách đơn hàng.xlsx</p>
                                                            <svg
                                                                className="MuiSvgIcon-root"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                aria-hidden="true"
                                                                style={{ color: "rgb(171, 171, 171)" }}>
                                                                <title>Xuất thông tin chi tiết đơn hàng</title>
                                                                <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z">
                                                                </path>
                                                            </svg>
                                                        </button>
                                                        <span className="MuiTouchRipple-root"></span>

                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </button>

                                {/* <button
                                    className="styles_btnOrder__wodZ1"
                                    title="Phản hồi"
                                    onClick={handleFeedback}
                                >
                                    <img
                                        data-origin-url="https://cdn-web-next.thuocsi.vn/orderStatus/iconFeedback.svg?size=origin"
                                        src="https://cdn-web-next.thuocsi.vn/orderStatus/iconFeedback.svg?size=origin"
                                        alt="Feedback icon"
                                        decoding="async"
                                        data-nimg="intrinsic"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%"
                                        }}
                                    />
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default OrderItem;